import {api} from "../../../../api/API";
import {useAsync2} from "nate-react-api-helpers";
import {useProjectId} from "../ProjectName";
import {useReload} from "../hardware/ReloadContext";
import {Alert} from "@mui/material";

const maxShown = 5;

export function PendingKeyedWarning() {
    const project = useProjectId();
    const list = useAsync2(input => api.keying2.getPending(input), {project: project}, [project]);
    useReload(list.reload, [list.reload]);

    const openings = list.asList.filter(v => !!v.opening && v.isKeyed);
    if (openings.length === 0) return null;

    const shown = openings.slice(0, maxShown);
    const more = openings.length - shown.length;

    return (
        <Alert severity="warning">
            The following openings have keyed hardware but are not assigned: {shown.map(v => v.baseBuilding ? v.name + " (Base Building)" : v.name).join(", ")}
            {more > 0 && ` (and ${more} more)`}
        </Alert>
    )
}
